<form
  #jccPaymentsForm
  class="checkout mx-2"
  action="{{ jccServerLink }}"
  class="d-none"
  [hidden]="true"
  method="POST"
>
  <div
    class="variant-wrapper d-flex flex-column justify-content-start align-items-start mx-3 my-2"
    style="max-width: 100%"
  >
    <input
      type="hidden"
      name="Version"
      value="{{ this.paymentData?.paymentFormParams?.version }}"
    />
    <input
      type="hidden"
      name="MerID"
      value="{{ this.paymentData?.paymentFormParams?.merchantId }}"
    />
    <input
      type="hidden"
      name="AcqID"
      value="{{ this.paymentData?.paymentFormParams?.acquirerId }}"
    />
    <input
      type="hidden"
      name="MerRespURL"
      value="{{ this.paymentData?.paymentFormParams?.responseUrl }}"
    />
    <input
      type="hidden"
      name="MerCallbackURL"
      value="{{ this.paymentData?.paymentFormParams?.callbackUrl }}"
    />
    <input
      type="hidden"
      name="PurchaseAmt"
      value="{{ this.paymentData?.paymentFormParams?.formattedPurchaseAmount }}"
    />
    <input
      type="hidden"
      name="PurchaseCurrency"
      value="{{ this.paymentData?.paymentFormParams?.currency }}"
    />
    <input
      type="hidden"
      name="PurchaseCurrencyExponent"
      value="{{ this.paymentData?.paymentFormParams?.currencyExponent }}"
    />
    <input
      type="hidden"
      name="OrderID"
      value="{{ this.paymentData?.paymentFormParams?.orderId }}"
    />
    <input
      type="hidden"
      name="CaptureFlag"
      value="{{ this.paymentData?.paymentFormParams?.captureFlag }}"
    />
    <input
      type="hidden"
      name="Signature"
      value="{{ this.paymentData?.paymentFormParams?.signature }}"
    />
    <input
      type="hidden"
      name="SignatureMethod"
      value="{{ this.paymentData?.paymentFormParams?.signatureMethod }}"
    />
  </div>
</form>
